<template>
  <div id="demo-mode">
    <div class="fixed-header" v-if="TestMode">
      <div class="header-content">
        <v-icon color="#ffffff" small class="mr-2">mdi-flask</v-icon>
        <span class="fixed-header-txt">YOU'RE IN TEST MODE</span>
      </div>
    </div>
  </div>
</template>

<script>
import companyConfig from "@/company_config.json";
export default {
  data() {
    return {
      TestMode: companyConfig.TestMode,
    };
  },
};
</script>

<style lang="scss" scoped>
#demo-mode {
  .fixed-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    /* Ensure it's above everything */
    height: 40px;
    background: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%);
    /* Modern Red/Orange Gradient */
    box-shadow: 0 2px 10px rgba(255, 75, 43, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .header-content {
    display: flex;
    align-items: center;
    animation: pulse 2s infinite;
  }

  .fixed-header-txt {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.85;
      transform: scale(0.98);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>